import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbCalendar, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ReportHttpService } from 'src/app/http/report-http.service';

@Component({
    selector: 'app-end-of-day-report',
    templateUrl: './end-of-day-report.component.html',
    styles: [],
})
export class EndOfDayReportComponent implements OnInit {
    constructor(
        private calendar: NgbCalendar,
        private activatedRoute: ActivatedRoute,
        private reportHttpService: ReportHttpService,
        private ngbDateParserFormatter: NgbDateParserFormatter
    ) {}

    model: NgbDateStruct;

    endOfDayReport: any;

    reportBusy: boolean;

    ngOnInit(): void {
        this.routeData();
        this.initDatePicker();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.endOfDayReport = data.data;
        });
    }

    initDatePicker() {
        this.model = this.calendar.getToday();
    }

    filterSubmit() {
        const modelFormatted = this.ngbDateParserFormatter.format(this.model);
        this.getEndOfDayReport(modelFormatted);
    }

    getEndOfDayReport(date: any) {
        this.reportBusy = true;
        this.reportHttpService.getEndOfDayReport(date).subscribe((data) => {
            this.endOfDayReport = data;
            this.reportBusy = false;
        });
    }
}
